import React, { useState, useEffect } from "react";
import { Modal, Input, Button, message } from "antd";
import CustomSelect from "../../../Reuseable/Select/Select";
import axios from "axios";
import "./EmployeeDetail.scss";
import { patchEmployeeDetails } from "../../../assets/api/allocation";
import { useDispatch, useSelector } from "react-redux";
import { fetchSupervisors, fetchTeamLeads } from "../../../store/userRoleSlice";

const EditDetailsModal = ({ open, onClose, employee }) => {
  const [loading, setLoading] = useState(false);
  const { token, user } = useSelector((state) => state.auth);
  const {
    // supervisors,
    // supervisors_loading,
    team_leads,
    supervisors,
    team_leads_loading,
    field_agents,
    field_agents_loading,
    telecallers,
    telecallers_loading,
  } = useSelector((state) => state?.userRoles);
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: "",
    role: "",
    email: "",
    phoneCode: "+91",
    phone: "",
    address: "",
    city: "",
    pincode: "",
    team_lead: "",
    supervisor: "",
  });

  useEffect(() => {
    if (employee) {
      setFormData({
        name: employee?.name || "",
        role: employee?.role || "",
        email: employee?.email || "",
        phoneCode: employee?.countryCode || "+91",
        phone: employee?.phone || "",
        address: employee?.address || "",
        city: employee?.city || "",
        pincode: employee?.pincode || "",
        team_lead: employee?.team_lead || "",
        supervisor: employee?.supervisor || "",
      });
    }
  }, [employee]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };
  
  const handleSubmit = async () => {
    if (!employee?.id) {
      message.error("Missing employee ID");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        id: employee.id,
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        city: formData.city,
        pincode: formData.pincode,
        team_lead: formData.team_lead,
        supervisor: formData.supervisor,
      };

      await patchEmployeeDetails(payload, token);
      message.success("Employee details updated successfully");
      onClose();
    } catch (error) {
      message.error("Failed to update employee details");

    } finally {
      setLoading(false);
    }
  };

  const teamLeadOptions =
    team_leads?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];
    
  const supervisorsOptions =
    supervisors?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

    
  useEffect(() => {
    if (open && user?.is_agency) {
      dispatch(fetchSupervisors());
      dispatch(fetchTeamLeads());
    }
  }, [dispatch, open, user]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      className="editDetailsModal"
      title="Edit Details"
      width={638}
    >
      <div className="editDetailsModal__formGrid">
        <div className="editDetailsModal__formItem">
          <label className="editDetailsModal__label">Name</label>
          <Input
            placeholder="Enter name"
            value={formData.name}
            onChange={(e) => handleChange("name", e.target.value)}
          />
        </div>

        <div className="editDetailsModal__formItem">
          <label className="editDetailsModal__label">Role</label>
          <CustomSelect
            value={formData.role}
            onChange={(value) => handleChange("role", value)}
            options={[
              { label: "Field Agent", value: "Field Agent" },
              { label: "Tele Caller", value: "Tele Caller" },
              { label: "Supervisor", value: "Supervisor" },
            ]}
            placeholder="Select Role"
            disabled
          />
        </div>

        <div className="editDetailsModal__formItem">
          <label className="editDetailsModal__label">Email</label>
          <Input
            placeholder="Enter email"
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
          />
        </div>

        <div className="editDetailsModal__formItem mobileNumWrapper">
          <label className="editDetailsModal__label">Contact no.</label>
          <div className="numInputWrapper">
            <CustomSelect
              value={formData.phoneCode}
              onChange={(value) => handleChange("phoneCode", value)}
              options={[
                { label: "+91", value: "+91" },
                { label: "+1", value: "+1" },
              ]}
              style={{ width: 100, marginRight: 8 }}
              placeholder="+91"
              disabled
            />
            <Input
              value={formData.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
              placeholder="9999999999"
              maxLength={10}
            />
          </div>
        </div>

        <div className="editDetailsModal__formItem addressWrapper">
          <label className="editDetailsModal__label">Address</label>
          <Input
            placeholder="Enter address"
            value={formData.address}
            onChange={(e) => handleChange("address", e.target.value)}
          />
        </div>

        <div className="editDetailsModal__formItem">
          <label className="editDetailsModal__label">City</label>
          <Input
            placeholder="Enter city"
            value={formData.city}
            onChange={(e) => handleChange("city", e.target.value)}
          />
        </div>

        <div className="editDetailsModal__formItem">
          <label className="editDetailsModal__label">Pin code</label>
          <Input
            placeholder="Enter pin code"
            value={formData.pincode}
            onChange={(e) => handleChange("pincode", e.target.value)}
          />
        </div>

        {
           (employee?.role !== 'Supervisor' && employee?.role !==
              "Team Lead") && (
                <div className="editDetailsModal__formItem">
          <CustomSelect
            label="TeamLead"
            placeholder="Select TeamLead"
            options={teamLeadOptions}
            onChange={(e) => handleChange("team_lead", e)}
            isMultiSelect={true}
          />
        </div>
              )
        }

        <div className="editDetailsModal__formItem">

          <CustomSelect
            label="Supervisor"
            placeholder="Select Supervisor"
            options={supervisorsOptions}
            onChange={(e) => handleChange("supervisor", e)}
            isMultiSelect={true}
          />
        </div>
      </div>

      <div className="editDetailsModal__submitWrapper">
        <Button
          type="primary"
          className="editDetailsModal__submitBtn"
          onClick={handleSubmit}
          loading={loading}
        >
          Submit
        </Button>
      </div>
    </Modal>
  );
};

export default EditDetailsModal;
